import React from 'react';
import SafeIcon from '../../common/SafeIcon';

const TrustBar=()=> {
  const features=[
    {icon: 'CheckCircle',text: '100% Philippine Ube'},
    {icon: 'MapPin',text: 'Family Farm Grown'},
    {icon: 'Star',text: '100% Real Ube'},
    {icon: 'Droplet',text: 'No Dyes or Fillers'},
    {icon: 'Truck',text: 'Ships from California'},
  ];

  return (
    <div className="bg-white border-y border-sand-light py-6">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center md:justify-between items-center gap-6 md:gap-4">
          {features.map((feature,index)=> (
            <div key={index} className="flex items-center space-x-2 text-gray-600">
              <SafeIcon name={feature.icon} className="w-5 h-5 text-ube" />
              <span className="text-sm font-medium tracking-wide">{feature.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrustBar;